import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { DashboardQueryProps } from "@customTypes/dashboard";

import { dashboardQKeys } from "./queryKeys";


const select = (
  res: any
):
  | {
      date: string;
      amountPaidIn: number;
      //   servicesPaidIn: number;
      outstandingPayIns: number;
      //   servicesOutstandingPayIns: number;
      amountPaidOut: number;
      //   servicesPaidOut: number;
      outstandingPayOuts: number;
      //   servicesOutstandingPayOuts: number;
    }[]
  | null => {
  //   console.log(res.data);
  const newData = [];

  if (Object.keys(res.data).length) {
    for (const i in res.data.data) {
      const {
        date,
        amount_paid_in,
        // count_paid_in,
        outstanding_pay_ins,
        // count_outstanding_pay_ins,
        amount_paid_out,
        // count_paid_out,
        outstanding_pay_outs,
        // count_outstanding_pay_outs,
      } = res.data.data[i];
      newData.push({
        date,
        amountPaidIn: amount_paid_in,
        // servicesPaidIn: count_paid_in,
        outstandingPayIns: outstanding_pay_ins,
        // servicesOutstandingPayIns: count_outstanding_pay_ins,
        amountPaidOut: amount_paid_out,
        // servicesPaidOut: count_paid_out,
        outstandingPayOuts: outstanding_pay_outs,
        // servicesOutstandingPayOuts: count_outstanding_pay_outs,
      });
    }

    return newData;
  }

  return null;
};

export const useGetEarningsDailyTrend = ({
  dateRange,
  startDate,
  endDate,
  userId,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.earningsDailyTrendWithFilters({
      dateRange,
      startDate,
      endDate,
      userId,
    }),
    queryFn: () => {
      return api.get("analytics/earnings/daily-trends", {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Earnings daily trend]", res);
      handleErrors(res, "query");
    },
  });
};
